import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69ab9040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"margin-top":"15px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "大写：", -1))
const _hoisted_5 = { class: "chinese" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "大写：", -1))
const _hoisted_9 = { class: "chinese" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'DESIGN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            size: "default",
            disabled: "",
            placeholder: _ctx.placeholder
          }, null, 8, ["placeholder"]),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.chinese), 1)
          ], 512), [
            [_vShow, _ctx.showChinese]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.readerMode)
            ? (_openBlock(), _createBlock(_component_el_input_number, {
                key: 0,
                modelValue: _ctx._value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._value) = $event)),
                style: {"width":"100%"},
                min: 0,
                "controls-position": "right",
                precision: _ctx.precision,
                size: "default",
                clearable: "",
                placeholder: _ctx.placeholder
              }, null, 8, ["modelValue", "precision", "placeholder"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                textContent: _toDisplayString(_ctx._value)
              }, null, 8, _hoisted_7)),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.chinese), 1)
          ], 512), [
            [_vShow, _ctx.showChinese]
          ])
        ]))
  ]))
}